import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProductPricing from "../../../model/ProductPricing";
import { __remove } from "../../axios_indicator";
import ProductPricingAPICall from "../../../service/ProductPricingAPICall";

export const fetchPricingFromServer = createAsyncThunk('product_pricing_fetchPricingFromServer',
    async (server_left_params) => {
        return await new ProductPricingAPICall().axiosFetchPricingFromServer(server_left_params)
    });

export const fetchPricingFromServerNew = createAsyncThunk('product_pricing_fetchPricingFromServerNew',
    async (res) => {
        return res
        // return await new ProductPricingAPICall().getPricingNew(server_left_params)
    });

const slice = createSlice({
    name: "ProductPricing",
    initialState: {
        data: {},
        master_data: {},
        master_data_new: {},
        bom_master_data: {},
    },
    reducers: {
        setAll: {
            reducer: (state, action) => {
                //Stopping unnecessary
                //state.data = action.payload.data
            },
        },
    },
    extraReducers: {
        [fetchPricingFromServer.fulfilled]: (state, { payload }) => {
            __remove('PRODUCT_PRICING_API_CALL');
            let data = payload;
            data = new ProductPricing().matchAll(data);
            data = new ProductPricing().processAll(data);
            data = Object.entries(data);
            if (data.length) {
                data.map((v, i) => {
                    if (state.data[v[0]] !== undefined) {
                        state.data[v[0]] = v[1];
                    }
                    state.master_data[v[0]] = v[1];
                });
            }
        },
        [fetchPricingFromServer.rejected]: (state, { payload }) => {
            __remove('PRODUCT_PRICING_API_CALL');
        },
        [fetchPricingFromServerNew.fulfilled]: (state, { payload }) => {
            __remove('PRODUCT_PRICING_API_CALL');
            let data = payload;

            if (Object.entries(data) && Object.entries(data).length > 0) {
                let priceTempArr = []
                Object.entries(data).map((v, i) => {
                    let partPrice = []
                    /**
                     * Here partNumber = ERPPartNumber & manufacturerPartNumber = ERPMFRPartNumber
                     */
                    // let uniqueNumber = v.partNumber ? v.partNumber : v.manufacturerPartNumber 
                    const _parent = {
                        "partNumber": v[1].partNumber,
                        "erpManufacturerCode": v[1].erpManufacturerCode,
                        "customerPartNumber": v[1].customerPartNumber,
                        "customerPartNumberOut": v[1].customerPartNumberOut,
                        "erpMfrPartNumber": v[1].erpMfrPartNumber,
                        "originalLine": v[1].originalLine,
                        "currency": v[1].currency,
                        "currIND": v[1].currIND,
                        "salesOrg": v[1].salesOrg,
                        "message": v[1].message,
                        "error": v[1].error
                    };

                    if (v[1] && v[1].prices && v[1].prices.length > 0) {
                        v[1].prices.map((p, j) => {
                            let _price = {
                                ..._parent,
                                ...p
                            }

                            // DT - 22/8/23 - US 13644: Zero Price being displayed when no price is returned.
                            if (v[1].prices.length > 1) {
                                partPrice.push(_price)
                            } else if (p.marketPrice) {
                                partPrice.push(_price)
                            }
                            
                        })
                    }

                    state.master_data_new[v[1].erpMfrPartNumber + '-' + v[1].partNumber] = partPrice;
                    if (v[1].customerPartNumber) {
                        /**
                         * state.bom_master_data this state is used when multiple entries available for same product
                         * Author: Devanshi Patel
                         */
                        state.bom_master_data[v[1].erpMfrPartNumber + '-' + v[1].partNumber + '-' + v[1].customerPartNumber] = partPrice;
                    } else {
                        state.bom_master_data[v[1].erpMfrPartNumber + '-' + v[1].partNumber] = partPrice;
                    }
                });
            }
        },
        [fetchPricingFromServerNew.rejected]: (state, { payload }) => {
            __remove('PRODUCT_PRICING_API_CALL');
        },
    },
})
    ;

export let { setAll } = slice.actions;

export default slice.reducer;
